import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import { Axios } from "../config";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "../Style/Subscribe.css";

const TEAMS = [
  {
    id: "Mavericks",
    label: "Shaheen Mavericks",
    formats: ["T20", "35Overs", "Weeknight"],
  },
  {
    id: "Gladiators",
    label: "Shaheen Gladiators",
    formats: ["T20", "35Overs", "Weeknight"],
  },
  {
    id: "Warriors",
    label: "Shaheen Warriors",
    formats: ["T20", "35Overs", "Weeknight"],
  },
  { id: "Knights", label: "Shaheen Knights", formats: ["T20", "35Overs"] },
  { id: "Titans", label: "Shaheen Titans", formats: ["35Overs"] },
];

const FORMAT_LABELS = {
  T20: "T20",
  "35Overs": "35 Overs",
  Weeknight: "Weeknight",
};

function Subscribe() {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [subscriptions, setSubscriptions] = useState([]);
  const [allGames, setAllGames] = useState(false);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const toggleSub = (teamId, formatId) => {
    const key = `${teamId}|${formatId}`;
    setSubscriptions((prev) =>
      prev.includes(key) ? prev.filter((s) => s !== key) : [...prev, key],
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    if (!name || !name.trim()) {
      setStatus("no_name");
      setLoading(false);
      return;
    }

    if (!phone || !isValidPhoneNumber(phone)) {
      setStatus("invalid");
      setLoading(false);
      return;
    }

    if (subscriptions.length === 0) {
      setStatus("no_teams");
      setLoading(false);
      return;
    }

    try {
      await Axios.post("/whatsapp/subscribe", {
        phone,
        name: name.trim(),
        teams: subscriptions,
        allGames,
      });

      setStatus("success");
      setPhone("");
      setName("");
      setSubscriptions([]);
      setAllGames(false);
    } catch (err) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="subscribe-page">
        <div className="subscribe-card">
          <div className="subscribe-icon">
            <i className="fab fa-whatsapp"></i>
          </div>

          <h1>Game Day Reminders</h1>

          <p className="subscribe-subtitle">
            Get WhatsApp reminders for Shaheen Cricket Club matches.
          </p>

          <form className="subscribe-form" onSubmit={handleSubmit}>
            <div className="subscribe-field">
              <label>
                Your Name <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="e.g. Shahzill"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="subscribe-field">
              <label>
                WhatsApp Number <span style={{ color: "#e74c3c" }}>*</span>
              </label>

              <PhoneInput
                international
                defaultCountry="CA"
                value={phone}
                onChange={setPhone}
                countryCallingCodeEditable={false}
                className="phone-input"
              />

              <span className="subscribe-hint">
                Select your country and enter your number
              </span>
            </div>

            <div className="subscribe-field">
              <label>
                Which teams &amp; formats do you play?{" "}
                <span style={{ color: "#e74c3c" }}>*</span>
              </label>
              <div className="teams-matrix">
                {TEAMS.map((team) => (
                  <div key={team.id} className="team-row">
                    <span className="team-row-name">{team.label}</span>
                    <div className="format-chips">
                      {team.formats.map((fmt) => {
                        const key = `${team.id}|${fmt}`;
                        const selected = subscriptions.includes(key);
                        return (
                          <button
                            key={fmt}
                            type="button"
                            className={`format-chip${selected ? " selected" : ""}`}
                            onClick={() => toggleSub(team.id, fmt)}
                          >
                            {selected && <i className="fas fa-check"></i>}
                            {FORMAT_LABELS[fmt]}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <label className="all-games-toggle">
              <input
                type="checkbox"
                checked={allGames}
                onChange={(e) => setAllGames(e.target.checked)}
              />
              <div className="all-games-toggle-text">
                <span className="all-games-toggle-title">
                  All Shaheen Games Summary
                </span>
                <span className="all-games-toggle-desc">
                  Also receive a full summary of every Shaheen game, not just
                  your teams
                </span>
              </div>
            </label>

            {status === "no_name" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Please enter your name
              </div>
            )}

            {status === "invalid" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Please enter a valid WhatsApp number
              </div>
            )}

            {status === "no_teams" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Please select at least one team and format
              </div>
            )}

            {status === "error" && (
              <div className="subscribe-message error">
                <i className="fas fa-exclamation-circle"></i>
                Something went wrong. Try again.
              </div>
            )}

            {status === "success" && (
              <div className="subscribe-message success">
                <i className="fab fa-whatsapp"></i>
                You're subscribed successfully!
              </div>
            )}

            <button type="submit" className="subscribe-btn" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Subscribing...
                </>
              ) : (
                <>
                  <i className="fab fa-whatsapp"></i> Subscribe
                </>
              )}
            </button>
          </form>

          <p className="subscribe-footer">
            To unsubscribe, visit{" "}
            <a href="/unsubscribe" style={{ color: "#aaa" }}>
              shaheenccyyc.com/unsubscribe
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Subscribe;
